module.exports = __webpack_public_path__ + "img/gis_bg.0f7318d1.png";